import { useTranslation } from '@mint-lib/i18n';
import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogOverlay,
  DialogRoot,
  DialogTitle,
  typographyVariants,
} from '@mint-lib/tw-components';

type ExitEditProps = {
  handleLeave: () => void;
  onClose: () => void;
  isOpen: boolean;
};

const ExitEdit = ({ handleLeave, onClose, isOpen }: ExitEditProps) => {
  const { t } = useTranslation('@mint-lib/recommendations-circuit');

  return (
    <Dialog open={isOpen} modal>
      <DialogOverlay />
      <DialogRoot
        size={'s'}
        onPointerDownOutside={(e) => e.preventDefault()} // Prevent closing the modal on outside click
        onEscapeKeyDown={(e) => e.preventDefault()} // Prevent closing the modal with Esc
      >
        <DialogHeader onClose={onClose}>
          <DialogTitle>{t('Leave edit mode?')}</DialogTitle>
        </DialogHeader>

        <DialogContent className="flex flex-col">
          <div className="flex flex-col">
            <p
              className={typographyVariants({
                variant: 'bodyLong01',
                color: 'secondary',
              })}
            >
              {t(
                'By clicking cancel the edit mode you will lose your changing. Do you want to exit edit mode?',
              )}
            </p>
            <p
              className={typographyVariants({
                variant: 'bodyLong01',
                color: 'secondary',
              })}
            >
              {t('Are you sure you want to delete the selected items?')}
            </p>
          </div>
        </DialogContent>
        <DialogFooter className="flex flex-row gap-2">
          <Button
            onClick={onClose}
            variant="plain"
            className="p-3"
            size="large"
          >
            {t('Cancel')}
          </Button>
          <Button
            onClick={handleLeave}
            variant="contained"
            color="warning"
            size="large"
          >
            {t('Yes, leave')}
          </Button>
        </DialogFooter>
      </DialogRoot>
    </Dialog>
  );
};
export default ExitEdit;
